import React from 'react'
import { Circle } from 'react-native-svg'

import { Color } from '../../style'

interface Props {
  x?: number
  y?: number
  datum?: any
  color?: string
}
const ChartDot = (props: Props) => {
  const { x, y, color } = props
  return <Circle cx={x} cy={y} r={3} fill={color || Color.premiumBlack} />
}

export default ChartDot
